import { theme } from 'antd';
import { DeletedFilled, EllipsisHorizontalIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import { DeleteBookingModal } from 'zComponents/molecules';
import { Button, Dropdown, Flex } from 'zui/Antd';

const ActionDropdown = ({ bookingID }) => {
	// ✅ Hooks
	const {
		token: { colorBgContainer, boxShadow, borderRadiusLG, paddingSM, fontWeightStrong, padding }
	} = theme.useToken();

	// ✅ Permissions
	const canDeleteBooking = useManagePermittedRoles('deleteBooking', bookingID);

	// ✅ Local States
	const [openDropdown, setOpenDropdown] = useState(false);

	const items = [
		{
			key: 'Delete Booking',
			label: (
				<DeleteBookingModal bookingID={bookingID}>
					<Button
						type='text'
						danger
						icon={<DeletedFilled width={16} height={16} color='currentColor' />}
						block
						disabled={!canDeleteBooking}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Delete Booking
					</Button>
				</DeleteBookingModal>
			)
		}
	];

	return (
		<Dropdown
			trigger={['click']}
			placement='bottomLeft'
			open={openDropdown}
			onOpenChange={(visible) => setOpenDropdown(visible)}
			dropdownRender={() => (
				<Flex
					style={{
						backgroundColor: colorBgContainer,
						borderRadius: borderRadiusLG,
						width: 196,
						boxShadow: boxShadow,
						padding: `${padding}px ${paddingSM}px`,
						position: 'relative'
					}}
					vertical
					gap={paddingSM}
				>
					{items.map((item) => (
						<div key={item.key} onClick={() => setOpenDropdown(false)}>
							{item.label}
						</div>
					))}
				</Flex>
			)}
		>
			<Button type='text' icon={<EllipsisHorizontalIcon />} />
		</Dropdown>
	);
};

export default ActionDropdown;
